import { useCallback, useEffect, useState } from "react";
import { useProductsContext } from "../../Contexts/SidebarContext";
import { CommonUtil } from "../../utils/CommonUtil";
import { NetworkManager } from "../../Components/NetworkManager";
import MmeLinkDataTable from "./MmeLinkDataTable";
import NewLinksDialogue from "./NewLinksDialogue";
import ToastManager from "../../Components/ToastManager";

export default function MmelinksPage() {
  const [linksList, setLinksList] = useState([]);
  const [newLinkDialogue, setNewLinkDialogue] = useState(false);
  const { sideBar, savePageIdAndName } = useProductsContext();
  const [openEditData, setOpenEditData] = useState<any>(null);

  const onSuccessGetLinks = useCallback((data: any) => {
    var respData = CommonUtil.parseData(data);
    if (respData) {
      if (respData.statusCode === "MKM0000") {
        const MmeLinks = respData.mmeLinks;
        setLinksList(MmeLinks);
      } else if (respData.statusCode === "MKM0005") {
        ToastManager.showToast("No MmeLinks for this pageId", "Error");
      }
    }
  }, []);
  const onErrorCall = useCallback(() => {}, []);

  const fetchMmeLinks = useCallback(async () => {
    const fbPageInfo: any = localStorage.getItem("fbPageDetail");
    const recFbPageInfp = JSON.parse(fbPageInfo)?.facebook;

    if (recFbPageInfp) {
      const pageId = recFbPageInfp?.fbPageId;
      const pageName = recFbPageInfp?.pageName;
      const fbAccountId = recFbPageInfp?.fbAccountId;

      if (pageId) {
        let pageDataReq = `pageId=${pageId}`;
        try {
          NetworkManager.sendJsonRequest(
            "marketingMessages/getMMELinks/rnTopic",
            "",
            pageDataReq,
            "GET",
            true,
            onSuccessGetLinks,
            onErrorCall
          );
        } catch (error) {
          console.log("Error fetching M.me links:", error);
        }
        savePageIdAndName(pageId, pageName, fbAccountId);
      }
    }
  }, [onSuccessGetLinks, onErrorCall, savePageIdAndName]);

  useEffect(() => {
    fetchMmeLinks();
  }, [fetchMmeLinks]);

  const handleMenu = () => {
    setNewLinkDialogue(true);
    setOpenEditData(null);
  };
  const onCancelDialogue = () => {
    setNewLinkDialogue(false);
  };
  const handleEditLink = (data: any) => {
    setNewLinkDialogue(true);
    setOpenEditData(data);
  };

  return (
    <div
      className="content-page"
      style={{
        marginLeft: sideBar ? "230px" : "120px",
        backgroundColor: "#fff",
      }}
    >
      <div className="content">
        <div className="container-fluid">
          <div className="sec-wrapper">
            <div className="d-flex justify-content-end mb-3">
              <button
                type="button"
                onClick={handleMenu}
                className="btn btn-primary rounded-pill new-chat"
              >
                Create New M.me Link
              </button>
            </div>
            <div
              className="tablerounededCorner table-responsive"
              style={{ borderRadius: 0 }}
            >
              <MmeLinkDataTable
                mmeLinks={linksList}
                onEditLink={handleEditLink}
              />
            </div>
          </div>
        </div>
      </div>
      {newLinkDialogue && (
        <NewLinksDialogue
          newLinkDialogue={true}
          saveLoadData={(flag: boolean) => {
            setNewLinkDialogue(false);
            fetchMmeLinks();
          }}
          onCancelDialogue={onCancelDialogue}
          setLinksList={setLinksList}
          openEditData={openEditData}
        />
      )}
    </div>
  );
}
